import { createIcon } from '@chakra-ui/icon';
import React from 'react';

export const CalculatorIcon = createIcon({
  path: (
    <path
      fill="currentColor"
      d="M7,2H17C18.1,2 19,2.9 19,4V20C19,21.1 18.1,22 17,22H7C5.9,22 5,21.1 5,20V4C5,2.9 5.9,2 7,2M7,4V8H17V4H7M7,10V12H9V10H7M11,10V12H13V10H11M15,10V12H17V10H15M7,14V16H9V14H7M11,14V16H13V14H11M15,14V16H17V14H15M7,18V20H9V18H7M11,18V20H13V18H11M15,18V20H17V18H15Z"
    />
  ),
  viewBox: '0 0 24 24',
});
